import { action, computed, makeObservable, observable } from "mobx";
import { Environments } from "../helpers/envinonment";
import { PartnerNames } from "../helpers/partner";
import { Steps } from "../helpers/step";
import { UserRole } from "../helpers/userRole";

export interface UiFlagsStore {
  partnerName: PartnerNames;
  setPartnerName: (partnerName: PartnerNames) => void;
  environment: Environments;
  setEnvironment: (environment: Environments) => void;
  apiDomain: string;
  setApiDomain: (domain: string) => void;
  sourceDomain: string;
  setSourceDomain: (domain: string) => void;
  isMobile: boolean;
  setMobileSize: () => void;
  setDesktopSize: () => void;
  isMobileSizeForPackages: boolean;
  setMobileSizeForPackages: () => void;
  setDesktopSizeForPackages: () => void;
  activeStep: Steps;
  incrementStep: () => void;
  decrementStep: () => void;
  setActiveStep: (step: Steps) => void;
  goToOfferCustomizerStep: () => void;
  goToApkStep: () => void;
  goToNewCalculation: () => void;
  goToProxiesExceededPage: () => void;
  goToAuthorizationForRenewalPage: () => void;
  isDirect: boolean;
  displayClientEnds: (userRoles: UserRole[] | undefined) => boolean;
  isClientEndsSelected: boolean;
  setIsClientEndsSelected: (isClientEndsSelected: boolean) => void;
  isOfferEdit: boolean;
  setIsOfferEdit: (isOfferEdit: boolean) => void;
  isDurAgent: boolean;
  setIsDurAgent: (isDurAgent: boolean) => void;
}

export class DefaultUiFlagsStore implements UiFlagsStore {
  constructor() {
    makeObservable(this);
  }

  @observable
  private _partnerName: PartnerNames = PartnerNames.default;

  @computed
  public get partnerName() {
    return this._partnerName;
  }

  @observable
  private _enableApk: boolean = true;

  @computed
  public get enableApk() {
    return this._enableApk;
  }

  @action
  public setPartnerName(partnerName: PartnerNames) {
    this._partnerName = partnerName;
  }

  @observable
  private _environment: Environments = Environments.default;

  @computed
  public get environment() {
    return this._environment;
  }

  @action
  public setEnvironment(environment: Environments) {
    this._environment = environment;
  }

  @computed
  public get isMobile() {
    return this._isMobile;
  }

  @observable
  private _isMobile: boolean = false;

  @action
  public setMobileSize() {
    this._isMobile = true;
  }

  @action
  public setDesktopSize() {
    this._isMobile = false;
  }

  @computed
  public get isMobileSizeForPackages() {
    return this._isMobileSizeForPackages;
  }

  @observable
  private _isMobileSizeForPackages: boolean = false;

  @action
  public setMobileSizeForPackages() {
    this._isMobileSizeForPackages = true;
  }

  @action
  public setDesktopSizeForPackages() {
    this._isMobileSizeForPackages = false;
  }

  @observable
  private _activeStep: Steps = Steps.apk;

  @computed
  public get activeStep() {
    return this._activeStep;
  }

  @action
  public setActiveStep(step: Steps) {
    return this._activeStep = step;
  }

  @action
  public incrementStep() {
    ++this._activeStep;
  }

  @action
  public decrementStep() {
    --this._activeStep;
  }

  @action
  public goToApkStep() {
    const tuzApkManager = document.querySelector('tuz-apk-manager') as HTMLElement;
    if (tuzApkManager) {
      tuzApkManager.style.display = '';
    }
    this._activeStep = Steps.apk;
  }

  @action
  public goToNewCalculation() {
    //flag used to enable/disable apk in case of faulty apk deployment
    if (this.enableApk) {
      const tuzApkManager = document.querySelector('tuz-apk-manager') as HTMLElement;
      if (tuzApkManager) {
        tuzApkManager.style.display = '';
      }
      this.setActiveStep(Steps.apk);
    }
    else {
      this.setActiveStep(Steps.questionsToOffer);
    }


  }

  @action goToProxiesExceededPage() {
    this._activeStep = Steps.proxiesExceeded;
  }

  @action goToAuthorizationForRenewalPage() {
    this._activeStep = Steps.authorizationForRenewal;
  }

  @action
  public goToOfferCustomizerStep() {
    this._activeStep = Steps.offerCustomizer;
  }

  @observable
  private _apiDomain = "";

  @computed
  public get apiDomain() {
    return this._apiDomain;
  }

  @action
  public setApiDomain(domain: string) {
    this._apiDomain = domain;
  }

  @observable
  private _sourceDomain = "";

  @computed
  public get sourceDomain() {
    return this._sourceDomain;
  }

  @action
  public setSourceDomain(domain: string) {
    this._sourceDomain = domain;
  }

  @computed
  public get isDirect() {
    return this.partnerName !== PartnerNames.sobol;
  }

  public displayClientEnds(userRoles: UserRole[] | undefined) {
    const clientEndsRole = [UserRole.KONCZY_KLIENT];

    return clientEndsRole.some(role => userRoles?.includes(role)) && this.partnerName === PartnerNames.sobol;
  }

  @observable
  private _isClientEndsSelected: boolean = false;

  @computed
  public get isClientEndsSelected() {
    return this._isClientEndsSelected;
  }

  @action
  public setIsClientEndsSelected(isClientEndsSelected: boolean) {
    this._isClientEndsSelected = isClientEndsSelected;
  }

  @observable _isOfferEdit = false;

  @computed
  public get isOfferEdit() {
    return this._isOfferEdit;
  }

  @action
  public setIsOfferEdit(isOfferEdit: boolean) {
    this._isOfferEdit = isOfferEdit;
  }

  @observable _isDurAgent = false;

  @computed
  public get isDurAgent() {
    return this._isDurAgent;
  }

  @action
  public setIsDurAgent(isDurAgent: boolean) {
    this._isDurAgent = isDurAgent;
  }
}